import React from "react";
import Gallery from "react-photo-gallery";
import { Box } from "@material-ui/core";
import classes from "./Photos.module.css";
import p1 from "../../asset/photos/photo1.jpg";
import p2 from "../../asset/photos/photo2.jpg";
import p3 from "../../asset/photos/photo3.jpg";
import p4 from "../../asset/photos/photo4.jpg";
import p5 from "../../asset/photos/photo5.jpg";
import p6 from "../../asset/photos/photo6.jpg";
import p7 from "../../asset/photos/photo7.jpg";
import p8 from "../../asset/photos/photo8.jpg";
import p9 from "../../asset/photos/photo9.jpg";
import p10 from "../../asset/photos/photo10.jpg";
import p11 from "../../asset/photos/photo11.jpg";
import p12 from "../../asset/photos/photo12.jpg";
import p13 from "../../asset/photos/photo13.jpg";
import p14 from "../../asset/photos/photo14.jpg";
import p15 from "../../asset/photos/photo15.jpg";
import p16 from "../../asset/photos/photo16.jpg";
import p17 from "../../asset/photos/photo17.jpg";
import p18 from "../../asset/photos/photo18.jpg";
import p19 from "../../asset/photos/photo19.jpg";
import p20 from "../../asset/photos/photo20.jpg";

import {Slide } from 'react-awesome-reveal';
const photos = [
  {
    src: p1,
    width: 52,
    height: 34,
  },
  {
    src: p17,
    width: 25,
    height: 10,
  },
  {
    src: p2,
    width: 52,
    height: 34,
  },
  {
    src: p3,
    width: 3,
    height: 2,
  },
  {
    src: p6,
    width: 300,
    height: 166,
  },
  {
    src: p7,
    width: 250,
    height: 154,
  },
  {
    src: p8,
    width: 23,
    height: 14,
  },
  {
    src: p9,
    width: 20,
    height: 11,
  },
  {
    src: p10,
    width: 25,
    height: 18,
  },
  {
    src: p4,
    width: 52,
    height: 34,
  },
  {
    src: p11,
    width: 23,
    height: 15,
  },
  {
    src: p5,
    width: 52,
    height: 34,
  },
  {
    src: p12,
    width: 25,
    height: 13,
  },
  {
    src: p13,
    width: 16,
    height: 18,
  },
  {
    src: p14,
    width: 23,
    height: 15,
  },
  {
    src: p15,
    width: 250,
    height: 166,
  },
  {
    src: p16,
    width: 15,
    height: 15,
  },
  {
    src: p18,
    width: 23,
    height: 15,
  },
  {
    src: p19,
    width: 15,
    height: 15,
  },
  {
    src: p20,
    width: 20,
    height: 13,
  },
];

const Photos = (props) => {
  return (
    <>
      <Box ml={4} mt={4}>
        <p className={classes.sectionName}>PHOTOS</p>
        <hr></hr>
      </Box>
      <Slide direction="left" triggerOnce="true">
        <Box mx={3}>
        <Gallery photos={photos}/>
        </Box>
      </Slide>
    </>
  );
};

export default Photos;
